
import { mapGetters } from "vuex";
import axios from 'axios';

//edited node_modules/vue-form-generator/dist/vfg.js for "(click here to show/hide options)"

export default {
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        businessName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
  },
  methods: {
    submitForm() {
      this.$refs['step2Form'].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          var _this = this;
          axios({url: "/mingdao/common/sysfeedback/mgxyContact.ht", method: 'post', 
            data: {
              firstName: _this.step2Form.firstName,
              lastName: _this.step2Form.lastName,
              email: _this.step2Form.email,
              phone: _this.step2Form.phone,
              content: "Partnership message: " + _this.step2Form.content
            },
            transformRequest: [function (data) {
              let ret = ''
              for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
              }
              return ret
            }],
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(res => {
            this.$router.push({
              path: `/`,
              query: {}
            });
          });
        } else {
          console.log('error submit!!');
        }
      });
    }
  },
  mounted() {
  },
	head() {
    return {
      title: 'Broker Program | American Credit',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Work alongside American Creditt to empower business owners with quick & simple financing options. We love helping people acheive the American Dream. Call us!'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'american credit partners, Experian, Plaid, Ocrolus, Salesforce, IBM, SBA, American Credit, amcredit'
        }
      ]
    }
  }
};
